
import React from 'react';

/**
 * Pushdown component displays content in a pushdown container with an optional icon
 * @param {Object} props
 * @param {React.ReactNode} [props.icon] - Optional icon element to display
 * @param {React.ReactNode} props.children - Content to display within the pushdown
 */
const Pushdown = ({ icon, children }) => {
  const hasIcon = Boolean(icon);

  return (
    <div className="pushdown" tracking-module="pushdown">
      <div className="pushdown__wrapper">
        {hasIcon && (
          <div className="pushdown__wrapper--icon">
            {icon}
          </div>
        )}

        <div className="pushdown__content">
          <div className="hgroup">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pushdown;
